/* ================== THE FLIGHT DECK ==================
   The deck list outgrew its dropdown: 23 doors in a 640px box meant two
   cramped columns, wrapped names and a hidden scroll. So when it opens it
   now takes the whole viewport — still the ship, just seen properly:
   nose cone at the top with the shop, bulkheads between the bays, engine
   at the foot. Plus a search field, because past about twenty doors
   people stop scanning and start looking for one.

   Built additively. It moves the existing panel, adds a search row and a
   way out, and touches nothing else.
   ==================================================================== */
(function () {
  if (window.STATION_FLIGHTDECK) return;

  var panel, btn, home, mark, input, count, closeBtn, wrapped = false;

  function rows() {
    return [].slice.call(panel.querySelectorAll('.menu-item'));
  }

  /* Each row is searchable by its name, its deck number, its colour chip
     and a few words a person would actually type. */
  var ALIASES = {
    'bottles': 'buy shop vessel bottle colour color claim purchase',
    'salvage': 'rare collector second hand used old',
    'the-unranked': 'black og black unranked verification verify test quiz specimen sigma unlisted rare alien identify who am i outside cascade impound',
    'freezer': 'cold cryo sold out waiting list restock',
    'approach': 'shipping arriving number claim reserve when',
    'fuel': 'gels mix drink nutrition food energy',
    'drop': 'invite secret entry password',
    'arcade': 'games play machines free fun',
    'mind-bay': 'puzzle brain teaser test memory',
    'redemption': 'prizes tickets counter redeem win',
    'purse': 'account coins tickets balance login sign in',
    'sightings': 'log burn trail spotted where map gps colorado',
    'hashtags': 'instagram social tags caption post share',
    'schoolhouse': 'kids children science learn space free school',
    'picture-house': 'film movie cinema video watch short',
    'partners': 'brand wholesale stock sell with us affiliate maker',
    'backroom': 'adults 18 swear rude',
    'dustfall': 'story origin history lore about',
    'crew': 'aliens characters five who',
    'ascension': 'stages levels ranks',
    'impound': 'lost found returns held',
    'reporting': 'found confirmed uplink transmission',
    'tracking': 'sightings network map'
  };

  function keyFor(row) {
    var href = row.getAttribute('href') || '';
    var route = row.getAttribute('data-route') || '';
    var m = href.match(/[?&]view=([a-z0-9-]+)/) || href.match(/\/pages\/([a-z0-9-]+)/) || href.match(/#\/([a-z0-9-]+)/);
    return (m ? m[1] : (route || href)).replace(/[?#].*$/, '');
  }

  function haystack(row) {
    var name = (row.querySelector('.mname') || {}).textContent || '';
    var num = (row.querySelector('.mnum') || {}).textContent || '';
    var chip = (row.querySelector('.mcolor') || {}).textContent || '';
    var slug = keyFor(row);
    return (name + ' ' + num + ' ' + chip + ' ' + slug + ' ' + (ALIASES[slug] || '')).toLowerCase();
  }

  /* ---- build the flight-deck chrome once ---- */
  function build() {
    if (wrapped) return;
    panel = document.getElementById('menuPanel');
    btn = document.getElementById('menuBtn');
    if (!panel || !btn) return;

    var head = document.createElement('div');
    head.className = 'fd-head';
    head.innerHTML =
      '<div class="fd-title"><span class="fd-k">THE FLIGHT DECK</span>' +
      '<b>Every deck on the station</b></div>' +
      '<div class="fd-find">' +
        '<input id="fdInput" type="search" autocomplete="off" placeholder="Search the ship — bottles, games, kids, partners\u2026" aria-label="Search the decks">' +
        '<span class="fd-count" id="fdCount"></span>' +
      '</div>' +
      '<button class="fd-close" id="fdClose" type="button" aria-label="Close the menu">\u2715</button>';
    panel.insertBefore(head, panel.firstChild);

    var empty = document.createElement('p');
    empty.className = 'fd-empty';
    empty.id = 'fdEmpty';
    empty.hidden = true;
    empty.innerHTML = 'Nothing on the ship by that name. <a href="/#/bottles">Try the vessel bay \u2192</a>';
    panel.appendChild(empty);

    input = head.querySelector('#fdInput');
    count = head.querySelector('#fdCount');
    closeBtn = head.querySelector('#fdClose');

    input.addEventListener('input', filter);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { input.value = ''; filter(); close(); }
      if (e.key === 'Enter') {
        var first = rows().filter(function (r) { return r.style.display !== 'none'; })[0];
        if (first) first.click();
      }
    });
    closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('open')) close();
    });

    wrapped = true;
  }

  function filter() {
    var q = (input.value || '').trim().toLowerCase();
    var shown = 0;
    rows().forEach(function (r) {
      var hit = !q || haystack(r).indexOf(q) > -1;
      r.style.display = hit ? '' : 'none';
      if (hit) shown++;
    });
    /* a bay with nothing left in it hides its own bulkhead */
    [].forEach.call(panel.querySelectorAll('.menu-bay'), function (bay) {
      var any = false, n = bay.nextElementSibling;
      while (n && !n.classList.contains('menu-bay')) {
        if (n.classList.contains('menu-item') && n.style.display !== 'none') { any = true; break; }
        n = n.nextElementSibling;
      }
      bay.style.display = any ? '' : 'none';
    });
    var eng = panel.querySelector('.menu-engine');
    if (eng) eng.style.display = q ? 'none' : '';
    var cta = panel.querySelector('.menu-cta');
    if (cta) cta.style.display = q ? 'none' : '';
    var empty = document.getElementById('fdEmpty');
    if (empty) empty.hidden = shown > 0;
    if (count) count.textContent = q ? (shown + (shown === 1 ? ' DECK' : ' DECKS')) : (rows().length + ' DECKS');
  }

  /* ---- open / close ----
     The panel lives inside the nav, whose own stacking context would trap a
     fixed overlay behind the page — the same trap the machines hit. So it is
     lifted to <body> while open and put back afterwards. */
  function lift() {
    if (home) return;
    home = panel.parentNode;
    mark = document.createComment('flightdeck');
    home.insertBefore(mark, panel);
    document.body.appendChild(panel);
  }
  function drop() {
    if (!home || !mark) return;
    home.insertBefore(panel, mark);
    mark.parentNode.removeChild(mark);
    home = mark = null;
  }

  function open() {
    build(); if (!panel) return;
    lift();
    panel.classList.add('open', 'fd');
    document.documentElement.classList.add('fd-on');
    btn.setAttribute('aria-expanded', 'true');
    if (input) { input.value = ''; filter(); if (window.innerWidth > 820) setTimeout(function () { input.focus(); }, 40); }
  }
  function close() {
    if (!panel) return;
    panel.classList.remove('open', 'fd');
    document.documentElement.classList.remove('fd-on');
    btn.setAttribute('aria-expanded', 'false');
    drop();
  }

  function boot() {
    build(); if (!panel) return setTimeout(boot, 300);
    /* take over the button — capture, so the old dropdown handler never runs */
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      panel.classList.contains('open') ? close() : open();
    }, true);
    /* any deck click closes the deck plan behind it */
    panel.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.menu-item, .menu-cta')) close();
    });
  }

  window.STATION_FLIGHTDECK = { open: open, close: close, filter: filter };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
